import * as d3ScaleChromatic from 'd3-scale-chromatic';

interface ColorScale {
    label: string;
    scale: (num: number) => string;
}

const greyColorScale: ColorScale = {
    label: 'Greys',
    scale: d3ScaleChromatic.interpolateGreys,
};

const colorScales: ColorScale[] = [
    {
        label: 'Green-Blue',
        scale: d3ScaleChromatic.interpolateGnBu,
    },
    {
        label: 'Yellow-Green-Blue',
        scale: d3ScaleChromatic.interpolateYlGnBu,
    },
    {
        label: 'Blues',
        scale: d3ScaleChromatic.interpolateBlues,
    },
    {
        label: 'Reds',
        scale: d3ScaleChromatic.interpolateReds,
    },
    {
        label: 'Greens',
        scale: d3ScaleChromatic.interpolateGreens,
    },
    greyColorScale,
    {
        label: 'Oranges',
        scale: d3ScaleChromatic.interpolateOranges,
    },
    {
        label: 'Purples',
        scale: d3ScaleChromatic.interpolatePurples,
    },
    {
        label: 'Turbo',
        scale: (percentage) => {
            const startAt = 0.1;
            return d3ScaleChromatic.interpolateTurbo((1 - startAt) * percentage + startAt);
        },
    },
];

export default colorScales;
export { ColorScale, greyColorScale };
